<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CF7O9w/tc-custom/9781640802728.jpg?1718282660410" alt="This image is the cover for the book Fire and Flint, Carlisle Deputies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fire and Flint, Carlisle Deputies
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Carlisle Deputies Novel</i></b></p><p>Jordan Erichsohn suspects something is rotten about his boss, Judge Crawford. Unfortunately he has nowhere to turn and doubts anyone will believe his claims—least of all the handsome deputy, Pierre Ravelle, who has been assigned to protect the judge after he received threatening letters. The judge has a long reach, and if he finds out Jordan’s turned on him, he might impede Jordan adopting his son, Jeremiah.</p><p>When Jordan can no longer stay silent, he gathers his courage and tells Pierre what he knows. To his surprise and relief, Pierre believes him, and Jordan finds an ally… and maybe more. Pierre vows to do what it takes to protect Jordan and Jeremiah and see justice done. He’s willing to fight for the man he’s growing to love and the family he’s starting to think of as his own. But Crawford is a powerful and dangerous enemy, and he’s not above ripping apart everything Jordan and Pierre are trying to build in order to save himself….</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Grey
      </h2>
      
      <p class="authorDescription body article">Andrew Grey is the author of more than one hundred works of Contemporary Gay Romantic fiction. After twenty-seven years in corporate America, he has now settled down in Central Pennsylvania with his husband of more than twenty-five years, Dominic, and his laptop. An interesting m&eacute;nage. Andrew grew up in western Michigan with a father who loved to tell stories and a mother who loved to read them. Since then he has lived throughout the country and traveled throughout the world. He is a recipient of the RWA Centennial Award, has a master&rsquo;s degree from the University of Wisconsin&ndash;Milwaukee, and now writes full-time. Andrew&rsquo;s hobbies include collecting antiques, gardening, and leaving his dirty dishes anywhere but in the sink (particularly when writing). He considers himself blessed with an accepting family, fantastic friends, and the world&rsquo;s most supportive and loving partner. Andrew currently lives in beautiful, historic Carlisle, Pennsylvania.<BR />Email: andrewgrey@comcast.net<BR />Website: www.andrewgreybooks.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e6f8e33